module.exports = {
  _name: "util",
  _prio: 0,
  _v: 1,
  methods: {
    util: require("./_helpers")
  }
};

;



//////////////////
// WEBPACK FOOTER
// /home/peaul/ceri/ceri/lib/util.js
// module id = 21
// module chunks = 1